import { Provider } from 'react-redux';
import store from './store';
import React from 'react';

export function ReduxProvicer({ children }) {
  return <Provider store={store}>{children}</Provider>;
}
